
import React from "react";

const SaveButton = ({
    title ="Guardar",
    width="w-[250px]",
    bg ="bg-green",
    onClick,
    disabled = false,
    loading=false,
    height="h-[64px]",
    rounded= "2xl"
 }) => {
    return(
        <button 
            type="submit"
            onClick={onClick}
            disabled={disabled  }
            className={`${width}  flex items-center justify-center  text-white font-itcdemi text-[18px] rounded-${rounded} py-[11px] px-[5px]
                ${height}
                ${disabled ? ' cursor-not-allowed bg-gray' : `cursor-pointer ${bg}`
            }`}
        >

            {loading ? 'Guardando...' : title}
        </button>

    );
};

export default SaveButton;